export const buildMlCampaignRequest = ({
    backendUrl,
    entId,
    isRegister,
    pricelistId,
    pricelistName,
    campaignId,
    plusPercent,
    campaignType,
    campaignExcelFile,
}) => {
    const url = campaignExcelFile
        ? `${backendUrl}/v1/ml-campaign/${entId}/send-from-excel-pricelist`
        : `${backendUrl}/v1/ml-campaign/${entId}/send-from-odoo-pricelist`;

    if (campaignExcelFile) {
        const formData = new FormData();
        formData.append('xlsx', campaignExcelFile);
        formData.append('isRegister', isRegister);
        formData.append('pricelistId', pricelistId);
        formData.append('pricelistName', pricelistName || '');
        formData.append('campaignId', campaignId);
        formData.append('plusPercent', plusPercent);
        if (campaignType) formData.append('campaignType', campaignType);

        return { url, payload: formData };
    }

    return {
        url,
        payload: {
            isRegister,
            pricelistId,
            campaignId,
            plusPercent,
            campaignType
        }
    };
};
